import { WebsocketCommandResponse } from '../MainWebsocketCommands';
import { WebsocketCommand } from '../useManagedWebsocket';

export class WebsocketCacheResetCommand extends WebsocketCommand {
    public async execute(changeCacheReset: (value: React.SetStateAction<boolean>) => void): Promise<WebsocketCommandResponse> {
        changeCacheReset(true);
        return { success: true };
    }
}
